var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayStep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 5.44772 0.447715 5 1 5H39C39.5523 5 40 5.44772 40 6V11H0V6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 15L0 15L0 34C0 34.5523 0.447714 35 0.999999 35H39C39.5523 35 40 34.5523 40 34V15ZM13 20H4L4 25H13V20Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayStep);
export default __webpack_public_path__ + "static/media/payStep.b1be0fb60f3313dff0ed6e18700eeea5.svg";
export { ForwardRef as ReactComponent };